module.exports = __webpack_public_path__ + "static/map-swiss-93a835bbe1f25aee37eb61f098fd6a68.svg";